import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "./api";

const TOKEN_KEY = "bazaar_member_token";
const AuthCtx = createContext(null);

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try { setUser((await http.get("/auth/me")).data); }
    catch { localStorage.removeItem(TOKEN_KEY); setUser(false); }
  }, []);

  useEffect(() => {
    refresh();
    const onFocus = () => localStorage.getItem(TOKEN_KEY) && refresh();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [refresh]);

  const signIn = (data) => { localStorage.setItem(TOKEN_KEY, data.token); setUser(data.user); refresh(); };
  const signOut = () => { localStorage.removeItem(TOKEN_KEY); setUser(false); };

  return <AuthCtx.Provider value={{ user, setUser, refresh, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const planLabel = (u) =>
  !u ? "" : u.plan_state === "active" ? (u.plan_id === "y1" ? "Member" : "Free") : u.plan_state === "expired" ? "Plan Expired" : "No Plan";
